import { supabase } from './supabase';

export async function checkSupabaseConnection() {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
  
  console.log('Checking Supabase configuration...');
  console.log('Supabase URL:', url ? '설정됨 ✓' : '누락됨 ✗');
  console.log('Supabase Key:', key ? '설정됨 ✓' : '누락됨 ✗');

  if (!url || !key) {
    console.error('Supabase 환경 변수가 누락되었습니다');
    return false;
  }

  try {
    const start = performance.now();
    
    // 세션 체크
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    const duration = performance.now() - start;

    console.log(`Supabase 응답 시간: ${duration.toFixed(2)}ms`);
    console.log('세션 상태:', session ? '있음 ✓' : '없음');
    console.log('Supabase 연결:', sessionError ? '실패 ✗' : '성공 ✓');
    
    if (sessionError) {
      console.error('세션 오류:', sessionError.message);
      return false;
    }

    // 데이터베이스 연결 테스트
    const { error: queryError } = await supabase
      .from('skus')
      .select('count')
      .limit(1)
      .single();

    const isQuerySuccessful = !queryError || queryError.message.includes('Results contain 0 rows');
    console.log('데이터베이스 연결:', isQuerySuccessful ? '성공 ✓' : '실패 ✗');

    if (!isQuerySuccessful) {
      console.error('데이터베이스 오류:', queryError.message);
      return false;
    }

    // 실시간 구독 테스트
    const channel = supabase.channel('test');
    const subscribePromise = new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject(new Error('실시간 연결 시간 초과')), 5000);
      channel
        .subscribe(status => {
          clearTimeout(timeout);
          resolve(status === 'SUBSCRIBED');
        })
        .unsubscribe();
    });

    try {
      await subscribePromise;
      console.log('실시간 연결: 성공 ✓');
    } catch (error) {
      console.error('실시간 연결: 실패 ✗');
      return false;
    }

    return true;
  } catch (err: any) {
    console.error('연결 확인 중 오류 발생:', err.message);
    return false;
  }
}